export function sanitizeText(text, trim = true) {
    const sanitizedText =
        typeof text === "string" ? (trim ? text.trim() : text).replace(/</gm, "&lt;").replace(/>/gm, "&gt;") : text;

    return sanitizedText;
}

export function properCase(text) {
    let result = text;

    if (typeof text === "string") {
        result = text.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    }

    return result;
}

export function isUUID(str) {
    return /^[0-9a-fA-Z][0-9a-fA-F]{7}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(str)
        ? true
        : false;
}

export function generateQueryString(queryString) {
    const params = new URLSearchParams();

    for (let param in queryString) {
        let value = queryString[param];

        if (value) {
            if (value instanceof Array) {
                value.forEach((valueItem) => {
                    params.append(`${param}[]`, valueItem);
                });
            } else {
                params.append(`${param}`, value);
            }
        }
    }

    const qs = params.toString();

    return qs.length > 0 ? `?${qs}` : "";
}
